var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg086QrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,170h50c33.084,0,60-26.916,60-60V60c0-33.084-26.916-60-60-60H60C26.916,0,0,26.916,0,60v50 C0,143.084,26.916,170,60,170z M40,60c0-11.028,8.972-20,20-20h50c11.028,0,20,8.972,20,20v50c0,11.028-8.972,20-20,20H60 c-11.028,0-20-8.972-20-20V60z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 355,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 355,
    width: 40,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 395,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280,512 280,472 319,472 319,512 359,512 359,472 320,472 320,432 240,432 240,512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440,512 440,475 472,475 472,435 400,435 400,512  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 65,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 407,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 356,
    width: 40,
    height: 76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 277,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,342H60c-33.084,0-60,26.916-60,60v50c0,33.084,26.916,60,60,60h50c33.084,0,60-26.916,60-60v-50 C170,368.916,143.084,342,110,342z M130,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20v-50c0-11.028,8.972-20,20-20 h50c11.028,0,20,8.972,20,20V452z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240,117 240,157 200,157 200,197 280,197 280,117  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 77,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,197h-73v40h-39v40h40v39h112v-80h-40V197z M472,276h-72v-39h72V276z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 197,
    width: 40,
    height: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,0h-50c-33.084,0-60,26.916-60,60v50c0,33.084,26.916,60,60,60h50c33.084,0,60-26.916,60-60V60 C512,26.916,485.084,0,452,0z M472,110c0,11.028-8.972,20-20,20h-50c-11.028,0-20-8.972-20-20V60c0-11.028,8.972-20,20-20h50 c11.028,0,20,8.972,20,20V110z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 65,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 197,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    y: 237,
    width: 40,
    height: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80,277 119,277 119,317 159,317 159,277 120,277 120,237 80,237  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 40,
    width: 40,
    height: 77
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240,317 240,356 280,356 280,395 360,395 360,355 280,355 280,316 240,316 240,237 200,237 200,317  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 197,
    width: 80,
    height: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg086QrCode);
export default __webpack_public_path__ + "static/media/086-qr-code.c1a95a133bc8318fd03e927d946397b4.svg";
export { ForwardRef as ReactComponent };